import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'; 
import { useQuery } from 'react-query'; 
import { fetch_account_transactions } from '../../services/apiSrv'; 
import Loader from 'components/widgets/loader'; 

function CommissionEntries() {
  const { id } = useParams(); 

  const { data: transactions, isLoading, isError, error } = useQuery(
    ['transactions', id], 
    async () => {
      console.log("Triggering fetch_account_transactions call with account number:", id); 
      const response = await fetch_account_transactions(id);
      console.log("API response for account transactions:", response); 
      return response.data || []; 
    },
    {
      enabled: !!id, // Ensure accountNumber exists
    }
  );


  if (isLoading) {
    console.log("Loading transactions for account:", id); // Log when data is being loaded
    return <Loader />; // Show a loader while fetching data
  }

  if (isError) {
    console.error("Error fetching transactions for account:", id, error.message); // Log the error message
    return <div>Error: {error.message}</div>; // Show an error if the request fails
  }

  console.log("Fetched transactions:", transactions); // Log the fetched transactions to check if the data is correct

  if (!transactions || !Array.isArray(transactions)) {
    console.error("Invalid transaction data:", transactions); // Log if the data is not in expected format
    return <div>No transactions available or incorrect data format.</div>;
  }

  return (
    <div className="mg-t-20">
      <h4>Account Transactions</h4>
      <div className="mg-b-20">
        <div className="card-body pd-0 collapse show">
          <div className="table-responsive">
            <table className="table table-hover mg-0">
              <thead className="tx-dark tx-uppercase tx-12 tx-bold">
                <tr className="bg-light">
                  <th className="">Tran Date</th>
                  <th className="">Tran Ref</th>
                  <th>Currency</th>
                  <th>Tran Amount</th>
                  <th>Debit/ Credit</th>
                   <th>Status</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {transactions?.map((transaction) => (
                  <tr key={transaction.transactionSystemRef}>
                    <td>{transaction.transactionDate}</td>
                    <td>{transaction.transactionRef}</td>
                    <td>{transaction.transactionCurrency}</td>
                    <td>{transaction.transactionAmount}</td>
                    <td>{transaction.transactionType}</td>
                    <td>{transaction.transactionStatus}</td>
                    {/* <td>
                      <a href={`/transaction/${transaction.transactionSystemRef}`} className="btn btn-sm btn-label-primary">
                        View
                      </a>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommissionEntries;